import { CuratedItemVariation } from "~types/types";

export function isFeaturedStyle(
    variation?: CuratedItemVariation,
    type?: string,
    brand?: string,
    franchise?: string
) {
    return (
        (type !== "newsletter_campaign" && franchise === "the-big-take") ||
        (type === "feature" && brand === "businessweek") ||
        (type === "feature" && franchise === "markets-magazine") ||
        variation === CuratedItemVariation.Featured ||
        variation === CuratedItemVariation.FeaturedWithoutByline
    );
}
